import type { ComponentProps } from "react";

/** コードブロックの中身は改行で終わる (インラインコードの改行は空白になる)。 */
export function isMarkdownCodeBlock({ className, children }: ComponentProps<"code">): boolean {
	return className?.includes("language-") || String(children).includes("\n");
}
